<div *ngIf="isLoading" class="overlay">
  <mat-spinner class="loading-spinner" diameter="50"></mat-spinner>
</div>

<mat-card class="news-form-card">
  <mat-card-title>{{ 'Create News' | translate }}</mat-card-title>
  <mat-card-content>

    <form [formGroup]="selectionForm" class="form-section">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Category' | translate }}</mat-label>
        <mat-select formControlName="categoryId">
          <mat-option *ngFor="let category of categories" [value]="category.id">
            {{ category.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="selectionForm.get('categoryId')?.value" appearance="outline" class="full-width">
        <mat-label>{{ 'Sub Category' | translate }}</mat-label>
        <mat-select formControlName="subCategoryId">
          <mat-option *ngFor="let subCategory of getSubCategories()" [value]="subCategory.id">
            {{ subCategory.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="selectionForm.get('subCategoryId')?.value" appearance="outline" class="full-width">
        <mat-label>{{ 'Nested Sub Category' | translate }}</mat-label>
        <mat-select formControlName="nestedSubCategoryId">
          <mat-option *ngFor="let nestedSubCategory of getNestedSubCategories()" [value]="nestedSubCategory.id">
            {{ nestedSubCategory.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div class="form-section">
      <h3>{{ 'News in Albanian' | translate }}</h3>
      <form [formGroup]="albanianForm">
        <mat-form-field appearance="outline" class="full-width" style="margin-bottom: 1rem">
          <mat-label>{{ 'Titulli i lajmit' | translate }}</mat-label>
          <input formControlName="title" matInput required>
          <mat-error *ngIf="albanianForm.get('title')?.invalid">{{ 'Title is required' | translate }}</mat-error>
          <mat-error  *ngIf="albanianForm.get('title')?.hasError('trailingSpace')">
            {{ 'Title cannot end with a space' | translate }}
          </mat-error>
        </mat-form-field>

        <br/>

        <label>{{ 'Përshkrimi i lajmit' | translate }}</label>
        <quill-editor formControlName="description"></quill-editor>
      </form>
    </div>

    <div class="form-section">
      <h3>{{ 'News in English' | translate }}</h3>
      <form [formGroup]="englishForm">
        <mat-form-field appearance="outline" class="full-width" style="margin-bottom: 1rem">
          <mat-label>{{ 'News Title' | translate }}</mat-label>
          <input formControlName="title" matInput>
          <mat-error *ngIf="englishForm.get('title')?.hasError('trailingSpace')">
            {{ 'Title cannot end with a space' | translate }}
          </mat-error>
        </mat-form-field>

        <br/>

        <label>{{ 'News Description' | translate }}</label>
        <quill-editor formControlName="description"></quill-editor>
      </form>
    </div>

    <div class="form-section image-upload-section">
      <div class="form-section">
        <h3>{{ 'Main Image' | translate }}</h3>

        <input (change)="onMainImageChange($event)" accept="image/*" type="file"/>

        <div>
          <h4>{{ 'Preview' | translate }}</h4>
          <img *ngIf="mainImagePreviewUrl" [src]="mainImagePreviewUrl" alt="Main image" class="image-preview">
        </div>

        <div style="margin-top: 5rem">
          <h4>{{ 'Crop Image' | translate }}</h4>
          <image-cropper
            (cropperReady)="cropperReady()"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (loadImageFailed)="loadImageFailed()"
            *ngIf="showCropper"
            [aspectRatio]="15 / 6"
            [imageChangedEvent]="imageChangedEvent"
            [imageQuality]="0.8"
            [maintainAspectRatio]="true"
            format="png">
          </image-cropper>
          <button (click)="saveCroppedImage()" color="primary" mat-button>
            {{ 'Save Cropped Image' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-section image-upload-section">
      <h3>{{ 'Upload Additional Images' | translate }}</h3>
      <input (change)="onAdditionalImagesChange($event)" accept="image/*" class="file-input" multiple
             style="margin-left: 17rem" type="file">
      <div class="additional-images-preview">
        <img *ngFor="let img of additionalImagePreviewUrls" [src]="img" alt="Additional image" class="image-preview">
      </div>
    </div>

    <div class="form-section image-upload-section">
      <h3>{{ 'Upload PDF Document' | translate }}</h3>
      <input
        (change)="onPdfChange($event)"
        accept="application/pdf"
        class="file-input"
        style="margin-left: 17rem"
        type="file"
      />
    </div>

    <div class="form-section">
      <h3>{{ 'Publish Date & Time' | translate }}</h3>
      <form [formGroup]="publishDateForm" style="display: flex; justify-content: space-between; gap: 2rem">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'Publish Date' | translate }}</mat-label>
          <input [matDatepicker]="picker" [width]="400" formControlName="date" matInput
                 required>
          <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error
            *ngIf="publishDateForm.get('date')?.invalid">{{ 'Publish Date is required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'Publish Time' | translate }}</mat-label>
          <input formControlName="time" matInput required type="time">
          <mat-error
            *ngIf="publishDateForm.get('time')?.invalid">{{ 'Publish Time is required' | translate }}
          </mat-error>
        </mat-form-field>
      </form>
    </div>

    <div class="form-section">
      <form [formGroup]="isMainPostForm" style="display: flex; flex-direction: row; gap: 2rem; align-items: center;">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'Mark as Main News' | translate }}</mat-label>
          <mat-select formControlName="isMainPost" required>
            <mat-option [value]="true">{{ 'Yes' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'No' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'Status' | translate }}</mat-label>
          <mat-select formControlName="status" required>
            <mat-option value="DRAFT">{{ 'Draft' | translate }}</mat-option>
            <mat-option value="PUBLISHED">{{ 'Published' | translate }}</mat-option>
            <mat-option value="SCHEDULED">{{ 'Scheduled' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>

    <div [formGroup]="videoUrlsForm" class="form-section">
      <h3>{{ 'Video URLs' | translate }}</h3>

      <div formArrayName="videoUrls">
        <div
          *ngFor="let control of videoUrls.controls; let i = index"
          style="display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem"
        >
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'Video URL' | translate }} {{ i + 1 }}</mat-label>
            <input matInput [formControlName]="i" placeholder="https://youtube.com/..."/>
            <mat-error *ngIf="control.invalid">{{ 'Video URL is required' | translate }}</mat-error>
          </mat-form-field>

          <button mat-icon-button color="primary" type="button" (click)="addVideoUrl()" matTooltip="Add">
            <mat-icon>add</mat-icon>
          </button>

          <button
            mat-icon-button
            color="warn"
            type="button"
            (click)="removeVideoUrl(i)"
            [disabled]="videoUrls.length === 1"
            matTooltip="Remove"
          >
            <mat-icon>remove</mat-icon>
          </button>
        </div>
      </div>
    </div>

  </mat-card-content>

  <mat-card-actions class="submit-button-container">
    <button (click)="onSubmit()" color="primary" mat-raised-button>{{ 'Ngarko lajmin' | translate }}</button>
  </mat-card-actions>
</mat-card>
